angular.module('EMR.EhrPermissionsSharedModule', []);